/** action-creator */
export const setSingleItems= (value) => {
  return { type: 'SET_SINGLEITEMS', value: value };
};
export const resetSingleItems = (value) => {
  return { type: 'RESET_SINGLEITEMS', value: value };
};

/** reducer */
const singleItems = (state = null, action) => {
    switch (action.type) {
      case 'SET_SINGLEITEMS':
          var newArray = action.value.slice();
          return newArray;
      case 'RESET_SINGLEITEMS':
            return [];
      default:
        return state
    }
  }
  export default singleItems;
